import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

// Get product detail
export const productDetailSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getProductDetail: builder.query({
      query: ({id, lang}) => ({
        url: `product/${id}/${lang}`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),
    // post update product status
    postUpdateProductStatus: builder.mutation({
      query: (data) => ({
        url: `product-status-update/${data?.product_id}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_LIST],
    }),
  }),
});

export const { useGetProductDetailQuery, usePostUpdateProductStatusMutation } =
  productDetailSlice;
